import { I18nUtils } from '@medable/i18n-core';
export const getLocaleRecords = async (locale) => {
    const i18nLocale = I18nUtils.cortexToI18nFormat(locale);
    const json = await import(`../../../../locales/lumos/${i18nLocale}.json`);
    return json.default;
};
export const getLanguageHeaders = (locale) => ({
    headers: {
        'Accept-Language': I18nUtils.cortexToI18nFormat(locale),
    },
});
